module.exports = __webpack_public_path__ + "img/3화_17(1).caf1c808.jpg";